import React, { useCallback } from 'react';

import useMediaStore from '../../common/store/useMediaStore';
import Menu from './Menu';
import SideNav from './SideNav';


const Navigation = () => {

  const md = useMediaStore(useCallback(state => state.md, []));

  return (
    <>
      <SideNav display={md} />
      <Menu display={!md} />
    </>
  );
}

export default Navigation;